import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { FilesListComponent } from './files-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { HttpClient } from "@angular/common/http";
import { FilesService } from './files.service';
import { Router } from '@angular/router';

@Component({
    selector: 'convfact-fileopen',
    templateUrl: './files-dialog.component.html',
    styleUrls: ['./files.component.css'],
    standalone: false
})

export class FilesDialogComponent {

  directory: string;
  path: string = this.data.path;
  error_msg: string;
  error: boolean = false;
  done: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<FilesListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private filesService: FilesService,
    private router: Router
  ) { }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  createDirectory() {
    if (this.directory == null || this.directory == "") {
      this.error = true;
      this.error_msg = "Debe indicar un directorio";
    } else {
      if (this.canCreateDirectory()) {
        this.filesService.createDirectory(this.directory, this.path).then(response => {
          this.displayInfo(response);
          this.done = true;
        })
      } else {
        this.error = true;
        this.error_msg = "No se puede crear un directorio con este nombre";
      }
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  canCreateDirectory(): boolean {
    const systemFolders = ['Facturas sin contabilizar', 'Facturas contabilizadas', 'Subvenciones', 'Inversiones', 'Otros documentos']
    if (this.router.url == '/files') {
      if (systemFolders.find(item => item.toLowerCase() == this.directory.toLowerCase()) != undefined) {
        return false;
      }
      return true;
    }
    return true;
  }

}
